import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedAddress } from '../../../../onboarding-business-insight.types';
import AddressCard from './components/address-card';
import MapComponent from './components/map';
import MapMarker from './components/map/components/map-marker';
import SatelliteImage from './components/map/components/satellite-image';
import useAddressCoordinates from './utils/use-address-coordinates';
export type OfficesProps = {
  data: FormattedAddress[];
};
const Content = t0 => {
  const $ = _c(25);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.offices"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const addresses = useAddressCoordinates(data);
  const located = addresses.filter(_temp);
  const [selectedId, setSelectedId] = useState();
  const selectedAddress = addresses.find(address_0 => address_0.id === selectedId) ?? located[0];
  const addressRefs = useRef({});
  useEffect(() => {
    const cardRef = selectedAddress && addressRefs.current[selectedAddress.id];
    if (cardRef?.parentElement) {
      cardRef.parentElement.scrollTo({
        top: cardRef.offsetTop - 16,
        behavior: "smooth"
      });
    }
  }, [selectedAddress?.id]);
  const markers = located.map(address_1 => <MapMarker key={address_1.id} id={address_1.id} onClick={() => setSelectedId(address_1.id)} latitude={address_1.latitude as number} longitude={address_1.longitude as number} isSelected={selectedAddress?.id === address_1.id} />);
  if (!data.length) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp2);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <Card.Empty>{t2}</Card.Empty>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== markers || $[6] !== selectedAddress || $[7] !== setSelectedId) {
    t2 = <MapComponent markers={markers} selectedAddress={selectedAddress} onSelect={setSelectedId} />;
    $[5] = markers;
    $[6] = selectedAddress;
    $[7] = setSelectedId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = selectedAddress?.latitude;
  const t4 = selectedAddress?.longitude;
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <SatelliteImage latitude={t3} longitude={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <div className="relative h-48 shrink-0 md:absolute md:inset-0 md:h-auto">{t2}{t5}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== addressRefs || $[16] !== addresses || $[17] !== selectedAddress?.id || $[18] !== setSelectedId) {
    t7 = addresses.map(address_2 => <AddressCard key={address_2.id} address={address_2} isSelected={selectedAddress?.id === address_2.id} onSelect={t8 => {
      const {
        id
      } = t8;
      return setSelectedId(id);
    }} ref={el => {
      addressRefs.current[address_2.id] = el;
    }} />);
    $[15] = addressRefs;
    $[16] = addresses;
    $[17] = selectedAddress?.id;
    $[18] = setSelectedId;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <div className="relative z-10 flex-1 min-h-0 bg-gradient-to-r from-background/95 to-background/80 md:flex-none md:h-full md:max-w-[280px]"><div className="overflow-y-auto p-4 space-y-2 h-full scrollbar-hide">{t7}</div></div>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t8) {
    t9 = <Card.Body className="overflow-hidden"><div className="relative flex flex-col w-full md:block md:h-[400px]">{t6}{t8}</div></Card.Body>;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default Content;
function _temp(address) {
  return address.latitude && address.longitude;
}
function _temp2($) {
  return $.empty;
}